// TEAMS Website - LanguageSwitcher Component
// Simple EN/IT language toggle

import React from 'react';
import { languageFlags, languageNames } from '../../data/translations.js';
import '../../styles/main.scss';

const LanguageSwitcher = ({ currentLanguage, onLanguageChange }) => {
  // Toggle between EN and IT
  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'it' : 'en';
    onLanguageChange(newLanguage);
  };

  return (
    <div className="language-switcher">
      <button
        className="language-switcher__current"
        onClick={toggleLanguage}
        aria-label="Toggle language"
      >
       
       
        <span className="language-switcher__toggle">
          {currentLanguage === 'en' ? 'Italiano' : 'English'}
        </span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
